import { notification } from "antd";
import "./index.scss";
export const nofication = (type, title, message) => {
    return(
        notification[type]({
            message: title,
            description: message,
        })
    )
};
